import { useState } from "react";
import { btn, inp } from "../styles/shared";

export default function AuthGate({ onUnlock }) {
  const [token, setToken] = useState("");

  function submit(e) {
    e.preventDefault();
    if (!token.trim()) return;
    onUnlock(token);
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg,#050508 0%,#070710 50%,#050508 100%)",
      color: "#e2e8f0",
      fontFamily: "'DM Sans',sans-serif",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 20,
    }}>
      <form onSubmit={submit} style={{
        width: "100%",
        maxWidth: 360,
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: 14,
        padding: "24px 22px",
        boxShadow: "0 18px 50px rgba(0,0,0,0.35)",
      }}>
        <div style={{ fontSize: 24, color: "#f97316", fontFamily: "'Arexa','Space Mono',monospace", letterSpacing: 2, marginBottom: 8 }}>
          SUBLIME
        </div>
        <div style={{ fontSize: 13, color: "#94a3b8", lineHeight: 1.5, marginBottom: 18 }}>
          Enter your app token to unlock your personal fitness data on this device.
        </div>
        <input
          autoFocus
          type="password"
          value={token}
          onChange={e => setToken(e.target.value)}
          placeholder="App token"
          style={{ ...inp, marginBottom: 12 }}
        />
        <button type="submit" style={{
          ...btn,
          width: "100%",
          padding: "10px 16px",
          fontSize: 14,
          background: "rgba(249,115,22,0.16)",
          color: "#f97316",
          border: "1px solid rgba(249,115,22,0.32)",
        }}>
          Unlock
        </button>
      </form>
    </div>
  );
}
